// removed by extract-text-webpack-plugin
module.exports = {"Container":"member__Container__1-wQW","Avatar":"member__Avatar___KKOv","Notification":"member__Notification__2sZXL","Row":"member__Row__30-LT","Role":"member__Role__SI-Ai","Edit":"member__Edit__1SRXC","Trash":"member__Trash__1fSX0","DropDownContainer":"member__DropDownContainer__3lJoF","DropDown":"member__DropDown__2jWde","CanRemoveContainer":"member__CanRemoveContainer__1HMRy","CanRemove":"member__CanRemove__1KttP","FlexRow":"member__FlexRow__1lLNz","Email":"member__Email__3Tfkr"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/Member/member.css
// module id = 893
// module chunks = 2